var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _circle2, _circle3, _circle4, _circle5, _circle6, _path8, _polygon, _path9, _polygon2, _path0, _path1, _polygon3, _path10, _path11, _path12, _path13, _path14, _polygon4, _circle7, _path15, _polygon5, _path16, _polygon6, _path17, _path18, _path19, _path20, _path21, _circle8, _path22, _path23, _path24, _path25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 931,
    height: 533,
    viewBox: "0 0 931 533",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b28c6922-ddd3-47e4-a3ac-36d7a7012cbe-615",
    "data-name": "Path 438",
    d: "M158.62942,669.19636a22.651,22.651,0,0,0,21.87279-3.8528c7.66093-6.43052,10.06334-17.02105,12.01715-26.82983L198.3,609.5l-12.10226,8.33312c-8.70382,5.99273-17.60312,12.178-23.629,20.858s-8.65478,20.52988-3.8146,29.92244",
    transform: "translate(-134.5 -183.5)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "f348d1cd-efe1-4e64-9555-bec9588846f0-616",
    "data-name": "Path 439",
    d: "M160.49813,706.34268c-1.52324-11.0976-3.09048-22.33872-2.01944-33.55532.94915-9.96166,3.98841-19.68961,10.17586-27.66934A46.02853,46.02853,0,0,1,180.464,634.41637c1.18065-.745,2.26756,1.12583,1.09195,1.868a43.7588,43.7588,0,0,0-17.30956,20.884c-3.76844,9.58445-4.37355,20.03294-3.72445,30.21457.39236,6.15714,1.22611,12.27392,2.06344,18.38348a1.12079,1.12079,0,0,1-.75585,1.33065,1.08834,1.08834,0,0,1-1.33067-.75583Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "a93533ad-4b65-413c-802a-4ad30488ecb9-617",
    "data-name": "Path 442",
    d: "M171.46229,688.53548a16.67411,16.67411,0,0,0,14.5285,7.50083c7.35657-.34909,13.487-5.48135,19.00519-10.35543l16.32508-14.4138L210.517,670.75c-7.76983-.37215-15.74016-.72123-23.14071,1.67758s-14.22557,8.16289-15.57861,15.82312",
    transform: "translate(-134.5 -183.5)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "b011e8a2-9a94-4c33-83aa-73d3f3df33bf-618",
    "data-name": "Path 443",
    d: "M156.19238,712.722c7.33348-12.9757,15.839-27.39672,31.0382-32.00611a34.6352,34.6352,0,0,1,13.0543-1.348c1.38621.11973,1.04,2.256-.34331,2.137a32.177,32.177,0,0,0-20.83349,5.51167c-5.87443,3.99851-10.44849,9.55777-14.31934,15.45238-2.37141,3.61122-4.49544,7.37532-6.61947,11.13437C157.49058,714.80492,155.50577,713.93728,156.19238,712.722Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#f2f2f2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 369.19291,
    cy: 160,
    r: 6,
    fill: "#e5e5e5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M647.18667,390.27051a421.89957,421.89957,0,0,1-67.00317-35.15137c-50.99634-32.80322-85.76758-70.74414-86.52393-94.41211-.22119-6.91748,2.34839-12.40332,7.63745-16.3042,8.55567-6.311,23.80884-7.82519,44.11157-4.38232l-.50146,2.958c-19.48071-3.30469-33.94507-1.97706-41.82935,3.83837-4.44751,3.28077-6.60742,7.92139-6.41992,13.79444.72632,22.72558,34.94507,59.6914,85.14868,91.98437a418.78342,418.78342,0,0,0,66.51734,34.89844Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M719.38906,408.044c-8.89721,0-19.43335-1.43213-31.41382-4.3042l.69922-2.917c25.15576,6.0293,44.1919,5.52784,53.6023-1.41357,4.44751-3.28076,6.60742-7.92188,6.41992-13.79443-.72656-22.72608-34.94507-59.69141-85.14868-91.98389-25.44458-16.36719-52.46924-29.998-78.15235-39.41846l1.03321-2.8164c25.88672,9.49511,53.11523,23.227,78.74219,39.71142,50.99609,32.80274,85.76757,70.74365,86.52392,94.41162.22119,6.91748-2.34839,12.40332-7.63745,16.3042C738.44033,405.96631,730.10342,408.044,719.38906,408.044Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M526.05239,408.01221c-10.74389.00049-19.1582-2.06055-24.75537-6.189-5.28906-3.90088-7.85864-9.38672-7.63745-16.3042.75635-23.668,35.52783-61.60888,86.52393-94.41162,56.99511-36.66113,120.96972-58.38818,152.1184-51.65869l-.6333,2.93262c-30.44506-6.58057-93.47143,14.97656-149.86206,51.24951-50.20361,32.29248-84.42212,69.25781-85.14868,91.98389-.18774,5.87255,1.97241,10.51367,6.41992,13.79443,22.52539,16.6123,94.51172-4.38672,160.47022-46.81348,45.30932-29.144,77.50439-61.75244,84.021-85.09961l2.88965.80664c-6.706,24.02491-39.38623,57.291-85.28759,86.81641-32.30323,20.77832-67.03711,37.10693-97.80347,45.97754C551.38687,405.70459,537.41665,408.01172,526.05239,408.01221Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 431.40518,
    cy: 62.5,
    r: 9,
    fill: "#6c63ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 531.90518,
    cy: 213,
    r: 9,
    fill: "#6c63ff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 559.90518,
    cy: 295,
    r: 6,
    fill: "#e5e5e5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 411.90518,
    cy: 6,
    r: 6,
    fill: "#e5e5e5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 610.90518,
    cy: 67,
    r: 9,
    fill: "#6c63ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M452.5,716.5h-317a1,1,0,0,1,0-2h317a1,1,0,0,1,0,2Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#cbcbcb"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "188.696 519.608 200.956 519.607 206.788 472.319 188.694 472.32 188.696 519.608",
    fill: "#ffb7b7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M320.0689,699.10505l24.144-.001h.001a15.3873,15.3873,0,0,1,15.38647,15.38624v.5l-39.53076.00146Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "139.696 520.608 151.956 520.607 157.788 473.319 139.694 473.32 139.696 520.608",
    fill: "#ffb7b7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M271.0689,700.10505l24.144-.001h.001a15.3873,15.3873,0,0,1,15.38647,15.38624v.5l-39.53076.00146Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#2f2e41"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M348.92613,504.295,342.69291,686.5h-20L303.73778,523.21973,295.69291,688.5h-25l-6.90732-195.77009,76.75025-1.05138Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "152.941 173.116 188.193 172 196.048 317.115 140.325 315.999 152.941 173.116",
    fill: "#cbcbcb"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M315.30288,508.5005l36.79807-1.05137-10.51373-52.56866,1.05137-30.48983,8.411-49.41455-23.13022-13.66785L322.6625,355s-8.411,8.411-8.411,47.3118S315.30288,508.5005,315.30288,508.5005Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M283.76168,507.44913s31.5412-75.94723,17.87335-109.99269c0,0-4.65253-37.19957-12.31431-42.45644l-11.86728,5.25687-25.233,12.61648,9.46236,26.28433-3.15412,22.07884L256.426,497.98677Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M262.02029,509.01583A9.85868,9.85868,0,0,1,258.1632,494.399L246.16035,475.3339l9.80681-10.11985,16.57221,27.16173a9.91213,9.91213,0,0,1-10.51908,16.64Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#ffb7b7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M357.88363,527.22918a9.85869,9.85869,0,0,1,.488-15.10925l-6.04378-21.703,12.29307-6.88952,8.10452,30.76872a9.91212,9.91212,0,0,1-14.84177,12.93306Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#ffb7b7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M263.78559,370.7706l-11.56511,2.10275-25.233,60.97965,23.13022,59.92828,15.7706-14.71923-14.71923-35.74669s1.05137-4.20549,0-4.73118,1.54481-3.91012,1.05137-4.17238c-1.05137-.5588,2.10275-5.81567,2.10275-5.81567l12.61648-26.28433Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "204.984 191.476 216.55 191.476 229.166 256.661 228.115 267.175 232.32 293.459 238.103 320.269 219.704 320.795 210.241 271.38 201.83 237.737 204.984 191.476",
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.158,
    cy: 138.85404,
    r: 24.56103,
    fill: "#ffb7b7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M325.16708,302.50943l4.36106-1.58584s-9.11854-9.11854-21.80531-8.3256l3.56823-3.56814s-8.72213-3.17163-16.65129,5.154c-4.16822,4.3766-8.9909,9.521-11.99731,15.31619h-4.67037l1.94922,3.89848L273.099,317.297l7.00247-.70027a19.67194,19.67194,0,0,0,.66233,10.09671l1.5858,4.361s6.34336-12.68663,6.34336-14.27248v3.96461s4.36107-3.5681,4.36107-5.94686l2.37876,2.77513,1.18938-4.36106,14.669,4.36106-2.37871-3.5681,9.11854,1.18938-3.56824-4.36106s10.30793,5.15394,10.70448,9.515c.39641,4.361,5.5503,9.91146,5.5503,9.91146l2.37872-3.9646S336.66438,308.45631,325.16708,302.50943Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#2f2e41"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "751.068 473.471 733.506 468.369 725.837 515.912 737.736 519.37 751.068 473.471",
    fill: "#9f616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M834.17794,703.79637l.50563-1.74071a13.234,13.234,0,0,1,16.40016-9.01717l24.6897,7.17162h0l-4.1971,14.44936h0L834.178,703.79638Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "860.711 471.858 842.422 471.857 848.317 519.652 860.708 519.653 860.711 471.858",
    fill: "#9f616a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M958.91917,714.65769l.00008-1.81267a13.23394,13.23394,0,0,1,13.23456-13.23332l25.71019.00118h0l-.00069,15.04659h0l-38.94412-.00178Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M978.39429,539.53959a10.21879,10.21879,0,0,0,4.79914-13.63137l-3.46385-32.61908-17.25869-7.37631,6.43395,35.54057a10.219,10.219,0,0,0,9.48945,18.08619Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#9f616a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M975.30563,451.68113l-20.24855-61.47032c-.42245-.70492-5.4624-8.63749-16.43744-5.26306a9.1778,9.1778,0,0,0-5.66912,4.62281c-3.21264,6.159-.21617,15.67371-.20282,15.72406l24.92919,55.86348.02594.05773,7.86865,57.37013,16.99294-3.45Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#6c63ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M840.72019,679.08723l30.4771-93.45537,35.33692-80.77108-.50873-39.17406,41.93375-9.77822,4.88325,16.41726c28.24221,18.63534,18.93843,54.48315,18.27452,56.88571l42.55411,157.0448-46.39975,5.15541-31.145-148.6925-28.72364,60.41863-20.30937,90.37692Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M903.00218,432.80184c-8.33744-15.98146-2.30956-22.06707,6.80562-31.27188a125.46624,125.46624,0,0,0,10.4661-11.56961c14.22078-18.28287,30.7254-9.3038,30.89056-9.21045l.09289.05209,4.07784,6.11643c13.438,13.5242-6.94027,50.6868-8.488,53.45441l1.02212,26.57355-43.3363,4.1271Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#6c63ff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 795.26904,
    cy: 164.53755,
    r: 24.82456,
    fill: "#9f616a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M919.51312,535.39192a10.21875,10.21875,0,0,0,19.3324-6.17638l4.90188-32.43415-14.83088-11.503-2.76758,36.01211a10.16371,10.16371,0,0,0-6.63582,14.10146Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#9f616a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M922.65381,518.50826l7.00073-58.30945-9.979-60.3387c-.02344-.42322-.51947-10.42975,4.39666-15.85341a10.03742,10.03742,0,0,1,7.2768-3.331c12.46834-.54605,15.44951,9.84159,15.47805,9.9462l4.06058,64.82131-9.16054,64.12507Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#6c63ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M904.45308,343.74l1.35122-2.17489A16.45657,16.45657,0,0,1,923.236,349.4077c.85251-3.14134,5.9198-2.97949,7.795-.319,1.87517,2.66056,1.4602,6.25544.85164,9.453-.60813,3.19747-1.29656,6.6725.1797,9.57331a8.87091,8.87091,0,0,0,7.75546,4.4105,16.499,16.499,0,0,0,8.80765-2.80283A30.15178,30.15178,0,0,0,962.36663,340.666a29.01211,29.01211,0,0,0-4.77517-12.25734,5.6659,5.6659,0,0,0,3.75424-1.82481,6.00826,6.00826,0,0,0,.65805-6.23954,11.305,11.305,0,0,0-3.68262-4.37045,9.17067,9.17067,0,0,0,3.89748,1.82009c1.75189.25257,3.79678-.65734,4.11408-2.34542.30255-1.60822-.98533-3.07178-2.17554-4.25065q-1.15785-1.14713-2.31618-2.29421a14.632,14.632,0,0,0,1.11382-1.42965A11.503,11.503,0,0,0,963.53123,295c2.209,3.77269.27086,8.26191-3.621,11.32051-.125.09826-.26565.18458-.39414.28035l-1.47669-1.4627a12.65267,12.65267,0,0,0-4.15445-3.10656c-1.63383-.62662-3.72082-.44329-4.78732.88621-1.14116,1.42308-.82169,3.68674-2.15731,4.93853-1.16851,1.0954-3.071.91195-4.64408.44983-1.57262-.46206-3.1982-1.13845-4.78818-.792a4.4965,4.4965,0,0,0-3.14351,5.1502,6.12993,6.12993,0,0,0,1.16286,2.59534,81.00228,81.00228,0,0,0-13.21124-.04089c-5.17581.28822-10.46448.647-15.23877,2.66729-4.77387,2.02025-9.01773,6.03884-9.89845,11.14737C896.29827,334.1421,899.28856,343.29089,904.45308,343.74Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.5,716.5h-317a1,1,0,0,1,0-2h317a1,1,0,0,1,0,2Z",
    transform: "translate(-134.5 -183.5)",
    fill: "#cbcbcb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/auto.57f6de84c30a7dea21831ebe1671a522.svg";
export { ForwardRef as ReactComponent };